export default __webpack_public_path__ + "static/16-5bb6e9d2114e55a06ec37b2c8c323aa4.png";